import {TOC_TOGGLE_CHAPTER, TOC_TOGGLE} from '../actions/toc.action';
import {BOOKMARK_POSTED} from '../actions/bookmark.action';
import {PROBLEM_OPENED} from '../actions/problem.action';
import {MODEL_LOAD} from '../actions/model.action.js';
import {SET_APP_OPTIONS} from '../actions/options.action.js';
import {getIdentifier} from '../helpers/api.js';
import {default_state} from './index.js';

function updateProblemBookmark(chapterId, problemId, chaptersData) {
  let chapters = JSON.parse(JSON.stringify(chaptersData)),
      problems = chapters[chapterId].problems;

  problems.map((problem, i)=>{
    if(problem.problemId == problemId) {
      return problem.isBookmarked = !problem.isBookmarked;
    }
  });

  return chapters;
}

function parseChapters(chapter_stack, bookmark_data, app_id, partner){
    let chapters = {},
        problems = {},
        problem_stack = [],
        i, chapter;

    for (i=0; chapter = chapter_stack[i]; i++) {
        chapters[chapter.chapterId] = chapter;
        if (chapter.problems){
            processProblems(chapter, bookmark_data);
        }
    }

    let has_chapters = chapter_stack.length > 0;

    return {
        chapters,
        problems,
        has_chapters,
        chapter_stack,
        problem_stack
    };

    function processProblems(chapter, bookmark_data){
        var i, problem, j;
        for (i=0; problem = chapter.problems[i]; i++) {
            problem.chapter = chapter.chapterId;
            problem.index = problem_stack.length;
            problem.identifier = getIdentifier(app_id,chapter, problem);
            problem.isBookmarked = false;
            //has this problem been bookmarked by the user
            for (j=0; j < bookmark_data.length; j++) {
              if(bookmark_data[j].id == problem.problemId) {
                problem.isBookmarked = true;
                break;
              }
            }

            problems[problem.identifier] = problem;
            problem_stack.push(problem);
        }
    }
}


export function toc(state=default_state.toc, action={}, full_state={}){

    switch (action.type){
        case MODEL_LOAD: {
            let toc = parseChapters(action.chapters, action.bookmark_data, full_state.app.id, full_state.options.partner_name);

            return {
                ...state,
                ...toc
            };
        }

        case TOC_TOGGLE_CHAPTER: {
            let opened_chapter = (state.opened_chapter == action.id) ? null : action.id;

            return {
                ...state,
                opened_chapter : opened_chapter
            };
        }

        case TOC_TOGGLE:
            return {
                ...state,
                visible : !state.visible
            };

        case PROBLEM_OPENED:
            return {
                ...state,
                opened_chapter : action.problem.chapter.chapterId
            };

        case BOOKMARK_POSTED: {
            let chapters = updateProblemBookmark(action.bookmarkData.chapterId, action.bookmarkData.id, full_state.toc.chapters);

            return {
                ...state,
                chapters: chapters
            };
        }

    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/toc.reducer.js